import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Menu, Typography } from "@mui/material";

export const CustomButton = styled(Button)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "16px",
  [theme.breakpoints.up("sm")]: { fontSize: "18px" },
  [theme.breakpoints.up("md")]: { fontSize: "20px" },
  padding: "8px 16px",
  backgroundColor: "#fd0000",
  boxShadow: "none",
  gap: "10px",
  color: "#fff !important", // ✅ Always white text
  transition: "all 0.3s ease-in-out",

  "&:hover": {
    backgroundColor: "#fd0000",
    color: "#fff !important", // ✅ Keep white text
  },

  // 🔥 Circular hover animation expanding from cursor position
  "&::before": {
    content: '""',
    position: "absolute",
    top: "var(--y, 50%)",
    left: "var(--x, 50%)",
    width: 0,
    height: 0,
    background: "rgba(0, 0, 0, 0.25)",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    transition: "width 0.6s ease, height 0.6s ease, opacity 0.3s ease",
    opacity: 0,
    zIndex: 0,
  },

  "&:hover::before": {
    width: "300%",
    height: "300%",
    opacity: 1,
  },

  // ✅ Make sure icon and text both stay white and above overlay
  "& .MuiButton-startIcon, & .MuiButton-endIcon, & img, & svg": {
    position: "relative",
    zIndex: 1,
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "#fff",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderRadius: "0 0 10px 10px",
    marginTop: "-1px",
    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
  },
}));

export const HeadingText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: "#000",
  // letterSpacing: "0.89px",
  fontSize: 30,
  lineHeight: "32px",
  marginBlockStart: "0px",
  [theme.breakpoints.up("sm")]: {
    fontSize: 40,
    lineHeight: "62px",
  },
}));
